<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="loaded ? room.name + (' Info' | translate) : ''"
      [canGoBack]="true"
      [showLinkIcon]="true"
      [linkIcon]="'trash'"
      (linkAction)="deleteRoom()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (loaded) {
      <form [formGroup]="form">
        <tidy-card>
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-input
              [label]="'Room Name'"
              formControlName="name"
              [form]="form.controls.name"
              [icon]="'assets/svg/list-circle.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter the name of the room.'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/home.svg'"
              [label]="'Floor'"
              [form]="form.controls.floor"
              formControlName="floor"
              [items]="floorSelectItems"
              [submitted]="submitted"
              [errorMessage]="'Please enter the floor the room is on.'" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [icon]="'assets/svg/ellipsis-horizontal-circle.svg'"
              [label]="'Room Type'"
              [form]="form.controls.category"
              formControlName="category"
              [items]="roomTypeSelectItems"
              [submitted]="submitted"
              [errorMessage]="'Please select the room type.'" />
          </tidy-row>
        </tidy-card>
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
        <tidy-button
          [text]="'Save Changes'"
          [action]="boundUpdateRoom"
          class="primary" />
      </form>
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
